// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface SignedSubscription
 */
export interface SignedSubscription {
  /**
   *
   */
  payload: string;
  /**
   *
   */
  signature: string;
}

/**
 * Check if a given object implements the SignedSubscription interface.
 */
export function instanceOfSignedSubscription(value: object): value is SignedSubscription {
  if (!("payload" in value) || value["payload"] === undefined) return false;
  if (!("signature" in value) || value["signature"] === undefined) return false;
  return true;
}

export function SignedSubscriptionFromJSON(json: any): SignedSubscription {
  return SignedSubscriptionFromJSONTyped(json, false);
}

export function SignedSubscriptionFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): SignedSubscription {
  if (json == null) {
    return json;
  }
  return {
    payload: json["payload"],
    signature: json["signature"],
  };
}

export function SignedSubscriptionToJSON(json: any): SignedSubscription {
  return SignedSubscriptionToJSONTyped(json, false);
}

export function SignedSubscriptionToJSONTyped(
  value?: SignedSubscription | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    payload: value["payload"],
    signature: value["signature"],
  };
}
